import { render } from "./webhookLabel.vue?vue&type=template&id=6885b872"
import script from "./webhookLabel.vue?vue&type=script&lang=js"
export * from "./webhookLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__